export const styles = () => ({
  svgAttachmentHolder: {
    boxSizing: 'border-box',
    cursor: 'pointer',
    padding: '20px 0px 20px 24px',
    height: 60,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
})
